import i18n from "i18next";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import type { AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { PurchaseOrdersView } from "src/components/views/erp/purchase/purchaseOrders/PurchaseOrdersView.tsx";
import { resolveValueOrProvider, ValueOrProvider } from "src/utils/valueOrProvider.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenPurchaseOrderButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	purchaseOrderId: ValueOrProvider<number | Promise<number>> | null | undefined;
}

export const OpenPurchaseOrderButton = ({
	purchaseOrderId: purchaseOrderIdProp,
	variant = "menu",
	...props
}: OpenPurchaseOrderButtonProps) => {
	const { openDialog } = useGenericDialog();

	if (purchaseOrderIdProp == null) return null;

	return (
		<AsyncButton
			label={i18n.t("open_purchase_order")}
			icon={faFileImport}
			variant={variant}
			onClick={async () => {
				if (purchaseOrderIdProp == null) return;
				const purchaseOrderId = await resolveValueOrProvider(purchaseOrderIdProp);
				openDialog({
					title: i18n.t("purchase_order"),
					agentContext: {
						key: defineAgentUiContextKey("erp.purchase.purchaseOrder.openPurchaseOrderButton.dialog"),
						data: { purchaseOrderId },
						pathSegments: [`${i18n.t("purchase_order")} ${purchaseOrderId}`],
					},
					content: <PurchaseOrdersView onlyPurchaseOrderId={purchaseOrderId} />,
				});
			}}
			{...props}
		/>
	);
};
